import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e7f23fd0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e7f23fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f23fd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7f23fd0')) {
      api.createRecord('e7f23fd0', component.options)
    } else {
      api.reload('e7f23fd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e7f23fd0&scoped=true&", function () {
      api.rerender('e7f23fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/headerNotice/index.vue"
export default component.exports